<template>
  <v-app dark>
    <home v-if="authLoaded && isAuthenticated"/>
    <login v-else-if="authLoaded && !isAuthenticated"/>
    <template v-else>
      <v-content>
        <v-container class="fill-height pa-0">
          <v-row class="fill-height ma-0 text-center" align="center" justify="center">
            <v-col>
              <v-progress-circular indeterminate/>
            </v-col>
          </v-row>
        </v-container>
      </v-content>
    </template>
  </v-app>
</template>

<script>
import {mapGetters} from 'vuex';
import Home from './views/Home';
import Login from './views/Login';

export default {
  name: 'App',
  components: {Login, Home},
  computed: {
    ...mapGetters('auth', [
      'authLoaded',
      'isAuthenticated'
    ])
  }
};
</script>

<style>
  .v-application.theme--dark {
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: black;
    color: #d8d8d8;
  }
  .theme--dark .v-card {
    background: black;
  }

  .display-1 {
    color: rgba(216, 216, 216, 0.5);
  }

  .section {
    height: 60vh;
    justify-items: center;
    text-align: center;
  }
  .section.start {
    height: 40vh;
  }

  @media screen and (orientation:landscape) {
    .section {
      height: 100vh;
      width: 50vw;
      display: inline-block;
    }
  }

  .v-btn--fab.v-size--small {
    margin: 2px;
  }
</style>
